<template>
  <div class="sendingRecords">
    <records-item :recordItem="item"
                  v-for="(item,index) in sendRecordList"
                  :taskRow="taskRow"
                  :lastRecord="lastRecord"
                  @closeDetail="closeDetail"
                  :ref=item.id
                  @confirmWithdraw="confirmWithdraw"
    ></records-item>
  </div>
</template>

<script>
import RecordsItem from "@/views/fissionMarketing/components/recordsItem";
export default {
  name: "sendingRecords",
  components: { RecordsItem },
  props:["sendRecordList","taskRow","lastRecord"],
  mounted() {
    this.$nextTick(()=>{
      console.debug('sendRecordList',this.sendRecordList)
    })

  },
  methods:{
    closeDetail(){
      this.$emit('closeDetail')
    },
    confirmWithdraw(){
      this.$emit('confirmWithdraw')
    }
  }
};
</script>

<style scoped lang="less">
.sendingRecords{
  padding: 10px 20px;
  height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>